/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import {oneSignalSubscription, setConstants, setUserAccess} from "../../../reduxStore/actions/commonAction";
import TopNavBarLoggedIn from "../../TopNavBarLoggedIn";
import SideNavBar from "../../SideNavbar";
import Footer from "../../Footer";
import ChatWindow from "../../../pages/Chat";
import Model from "../../../components/modal";
import VideoInstruction1 from "../../../assets/images/Video_Allow_Instruction_11.jpg";
import VideoInstruction2 from "../../../assets/images/Video_Allow_Instruction_22.jpg";
import audioVideoTest from "../../../utils/audioVideoTest";
import Label from "../../../components/label";
import IpadRotateImg from "../../../assets/images/ipad_rotate.jpeg";
import EulaPopup from "../../../components/EulaPopup";

import SocketHandler from "../../../containers/SocketHandler";
import {appConstants} from "../../../apiRoutes";
import {MakeAPICall} from "../../../apiCalls/common";

const DashboardLayout = props => {
  // const [subscribeModelStatus, setSubscribedModelStatus] = useState(!props.userSubscribed);  // default user subscribed is false
  const [cameraStatusModelOpen, setCameraStatusModelOpen] = useState(false); // camera supported or not model
  const [audioVideoStatusModelOpen, setAudioVideoStatusModelOpen] = useState(
    false
  ); // check audio and video (if test fails then open this model)

  const [appointmentInProgress, setAppointmentInProgress] = useState(false); // if doctor accepted appointment then we have to set side bar to display none because appointment is not completed by doctor

  const [onlineAssessmentInProgress, setOnlineAssessmentInProgress] = useState(false); // If Instant Switch Online assessment in progress means if doctor has accepted assessment

  const [isLocalDataSetupDone, setIsLocalDataSetupDone] = useState(false);
  const [apiCall2, setApiCall2] = useState(null);
  const [shouldCheckEula, setShouldCheckEula] = useState(false);

  /*
   * Close subscribed model
   */

  // const closeSubscribeModel = () => {
  //   setSubscribedModelStatus(false);
  // };

  /*
   * Close camera status model
   */

  const closeCameraStatusModel = () => {
    setCameraStatusModelOpen(false);
  };

  const getConstants = () => {
    let apiCallParam2 = {
      reqType: "GET",
      reqURL: appConstants,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        props.setConstants(res.data.data);
        // Trigger EULA check after constants are loaded
        setShouldCheckEula(true);
      },
      failureCallback: err => {
        console.log("Something went wrong, Please try again. ", err);
      },
      showPopUp: false
    };

    setApiCall2(apiCallParam2);

  }

  /*
   * Close audio & video test model
   */

  const closeAudioVideoStatusModelOpen = () => {
    setAudioVideoStatusModelOpen(false);
  };

  const testAudioVideo = () => {
    audioVideoTest(data => {
      if (data[0] === false) setCameraStatusModelOpen(true);
      else if (data[1] === false) setAudioVideoStatusModelOpen(true);
      else console.log("Audio Video Working Good");
    });
  }

  useEffect(() => {
    getConstants();
    if (props.auth && props.auth.user && props.auth.user.userData) {
      console.log("Now checking access -> ", props.auth.user.userData);
      let isInstantConsultAccessGranted = false;
      let isInstantSwitchAccessGranted = props.auth.user.userData.isAccessToInstantSwitch ? true : false;
      let isInstantSwitchMCAccessGranted = props.auth.user.userData.isAccessToInstantSwitchMC ? true : false;
      let isInstantHushAccessGranted = props.auth.user.userData.isAccessToInstantHush ? true : false;

      const instantConsultTemplates = props.auth.user.userData.templateChoices;

      for (const template in instantConsultTemplates) {
        if (instantConsultTemplates[template]) {
          isInstantConsultAccessGranted = true;
          break
        }
      }
      const accessDataToSet = {
        isInstantConsultAccessGranted: isInstantConsultAccessGranted,
        isInstantSwitchAccessGranted: isInstantSwitchAccessGranted,
        isInstantHushAccessGranted: isInstantHushAccessGranted,
        isInstantSwitchMCAccessGranted: isInstantSwitchMCAccessGranted
      };

      // if instant consult access granted then audio-video test needed
      if (isInstantConsultAccessGranted) {
        testAudioVideo();
      }

      props.setUserAccess(accessDataToSet);
      if (isLocalDataSetupDone === false) {
        setIsLocalDataSetupDone(true);
      }
    }
  }, [])

  useEffect(() => {
    console.log("Common Reducers in Dashboard : ", props.commonReducers);
    if (props.commonReducers.appointmentData) setAppointmentInProgress(true);
    else setAppointmentInProgress(false);

    if (props.commonReducers.isOnlineAssessmentStarted) {
      setOnlineAssessmentInProgress(true);
    } else {
      setOnlineAssessmentInProgress(false);
    }
  }, [props.commonReducers.appointmentData, props.commonReducers.isOnlineAssessmentStarted]);

  return (
    <Fragment>
      <div className="ipad-portrait-mode">
        <div className="msg-div p-0">
          <Label title="Please Use Landscape Mode" className="large w-100 title-lable" />
          <Label title="Rotate Your Device" className="w-100 text-center pb-0 mb-0" />
          <img src={IpadRotateImg} alt="Ipad Rotate Instruction" className="w-100 mt-2" />
        </div>
      </div>
      <TopNavBarLoggedIn />
      <div className="main-content">
        <div className="container-fluid">
          <div className="row p-3 mb-5">
            <div
              className={
                (appointmentInProgress || onlineAssessmentInProgress)
                  ? "d-none"
                  : "col-sm-3 pl-4 pr-4 left-column"
              }
            >
              {
                isLocalDataSetupDone && (
                  <SideNavBar />
                )
              }
            </div>
            <div
              className={
                (appointmentInProgress || onlineAssessmentInProgress)
                  ? (onlineAssessmentInProgress ? "col-sm-12 bg-white right-column-assessment-progress" : "col-sm-12 bg-white right-column-appointment-progress")
                  : "col-sm-9 bg-white right-column"
              }
            >
              {props.children}
            </div>
          </div>
        </div>
      </div>
      <Footer privacyPolicyLink={props.commonReducers && props.commonReducers.constants ? props.commonReducers.constants.privacyPolicy : ''} />
      <SocketHandler />
      <ChatWindow />
      <EulaPopup shouldCheckEula={shouldCheckEula} />

      {/*
       * User subscribed or not check model
       */}

      {/* <Model
        openModal={subscribeModelStatus}
        modalBodyContent="Please Subscribe to Notifications"
        okayText="Okay"
        cancelText="Okay"
        title="Instant Consult"
        useOneButton={true}
        okayEvent={closeSubscribeModel}
        cancelEvent={closeSubscribeModel}
      /> */}

      {/*
       * Camera status model
       */}

      <Model
        openModal={cameraStatusModelOpen}
        modalBodyContent="You will be unable to connect with patients <br> <br> You must login to another device <br>(with camera/microphone installed)<br> if you are accepting consult requests</p>"
        okayText="Okay"
        cancelText="Okay"
        title="Camera/Microphone Not Detected"
        useOneButton={true}
        okayEvent={closeCameraStatusModel}
        cancelEvent={closeCameraStatusModel}
      />

      {/*
       * Audio & Video Test Result model
       */}

      <Model
        openModal={audioVideoStatusModelOpen}
        modalBodyContent={`
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <br />
            <p class="You-have-a-new-Consu">Please follow these instructions to allow your <br/> Camera & Microphone to proceed</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <img src="${VideoInstruction1}" style="width: 100%" alt="video-allow-instruction-1" />
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <br />
            <p class="You-have-a-new-Consu">Then please click on Reload</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <img src="${VideoInstruction2}" style="width: 100%" alt="video-allow-instruction-1" />
        </div>
      `}
        okayText="Okay"
        cancelText="Okay"
        title="Camera/Microphone Not Detected"
        useOneButton={true}
        okayEvent={closeAudioVideoStatusModelOpen}
        cancelEvent={closeAudioVideoStatusModelOpen}
      />

      <MakeAPICall apiParam={apiCall2} />
    </Fragment>
  );
};

// export default DashboardLayout;

const mapStateToProps = props => ({
  userSubscribed:
    props.commonReducers &&
    props.commonReducers.oneSignalSubscribed &&
    props.commonReducers.oneSignalSubscribed.isSubscribed
      ? props.commonReducers.oneSignalSubscribed.isSubscribed
      : false,
  commonReducers: props.commonReducers,
  auth: props.auth
});

const mapDispatchToProps = dispatch => ({
  oneSignalSubscription: data => dispatch(oneSignalSubscription(data)),
  setUserAccess: data => dispatch(setUserAccess(data)),
  setConstants: data => dispatch(setConstants(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(DashboardLayout);
